import { useState, useEffect } from "react";
import { DOC_TYPES, DEFAULT_DOC_TYPE } from "@/lib/files";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";

export function DocTypeDialog({ open, files, onConfirm, onCancel }) {
  const [docType, setDocType] = useState(DEFAULT_DOC_TYPE);
  const count = files?.length || 0;

  useEffect(() => { if (open) setDocType(DEFAULT_DOC_TYPE); }, [open]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="rounded-sm sm:max-w-md" data-testid="doc-type-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <FileText className="w-4 h-4 text-[#002FA7]" /> Categorize {count > 1 ? `${count} files` : "file"}
          </DialogTitle>
          <DialogDescription>
            Choose what type of document {count > 1 ? "these are" : "this is"}. You can change it later.
          </DialogDescription>
        </DialogHeader>

        {count > 0 && (
          <ul className="text-xs text-gray-500 max-h-24 overflow-y-auto space-y-1 -mt-1">
            {files.map((f, i) => (
              <li key={`${f.name}-${i}`} className="truncate">• {f.name}</li>
            ))}
          </ul>
        )}

        <label className="block text-sm font-semibold text-gray-700 mt-1">Document type</label>
        <Select value={docType} onValueChange={setDocType}>
          <SelectTrigger className="rounded-sm" data-testid="doc-type-select-trigger">
            <SelectValue placeholder="Select a type" />
          </SelectTrigger>
          <SelectContent>
            {DOC_TYPES.map((t) => (
              <SelectItem key={t.value} value={t.value} data-testid={`doc-type-option-${t.value}`}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <DialogFooter className="mt-2">
          <Button variant="outline" className="rounded-sm" onClick={onCancel} data-testid="doc-type-cancel-button">
            Cancel
          </Button>
          <Button className="rounded-sm bg-[#002FA7] hover:bg-[#002480]" onClick={() => onConfirm(docType)}
            data-testid="doc-type-confirm-button">
            Upload
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
